var _style, _defs, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthquakeSoilConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000114061113650107822180000017674754384754118813_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172414316004113382460000016804917766977788548_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172414316004113382460000016804917766977788548_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 8.5-1.2 1.8c-.2.3-.6.5-.9.5H1.3c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h3.9l2-3c.5-.7 1.6-.6 2 .2l2.6 5.9 2.7-8.8c.3-1 1.7-1.1 2.1-.1l2.5 5.9h3.5c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1h-4.3c-.4 0-.9-.3-1-.7l-1.6-3.7-2.7 8.8c-.3 1-1.7 1.1-2.1.1L8 8.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 17.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5 12 3 5.2h-6.1l3.1-5.2zM5 18l-2.6-4.5h5.2L5 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquakeSoilConditions);
export default __webpack_public_path__ + "static/media/earthquake_soil_conditions.41b07319fce0a70a558afb464136c1c1.svg";
export { ForwardRef as ReactComponent };